interface ReturnPathRouter {
  matchRoutes: (pathname: string) => unknown[];
}

export const safeReturnPath = (pathname: string, search: string, hash: string) =>
  `${pathname}${search}${hash}`;

export const restoreReturnPath = (router: ReturnPathRouter, returnTo?: string) => {
  if (!returnTo) {
    return "/";
  }

  let url: URL;

  try {
    url = new URL(returnTo, window.location.origin);
  } catch {
    return "/";
  }

  return url.origin === window.location.origin && router.matchRoutes(url.pathname).length > 1
    ? `${url.pathname}${url.search}${url.hash}`
    : "/";
};
